// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/smoking-prohibition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/smoking-prohibition/smoking-prohibition.js';

mount([g0]);
